/* ============================================
   AQIRYS PREMIUM - JavaScript Interactions
   ============================================ */

(function() {
  'use strict';

  /* --- Sticky Add to Cart Bar --- */
  function initStickyATC() {
    const stickyBar = document.getElementById('aq-sticky-atc');
    if (!stickyBar) return;

    const productForm = document.querySelector('.product-form__submit');
    if (!productForm) return;

    const stickyBtn = document.getElementById('aq-sticky-atc-btn');

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      },
      { threshold: 0, rootMargin: '-100px 0px 0px 0px' }
    );

    observer.observe(productForm);

    // Click handler - scroll to form or submit
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        const mainForm = document.querySelector('product-form form');
        if (mainForm) {
          // Submit the main product form
          const submitBtn = mainForm.querySelector('[type="submit"]');
          if (submitBtn && !submitBtn.disabled) {
            submitBtn.click();
          } else {
            // Scroll to the form
            productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    }
  }

  /* --- Animate on Scroll --- */
  function initScrollAnimations() {
    const elements = document.querySelectorAll('.aq-animate-in, .aq-trust__item, .aq-category-card');

    if (!elements.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    elements.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

  /* --- Product Card Hover Enhancement --- */
  function initCardHoverEffects() {
    const cards = document.querySelectorAll('.card-wrapper.product-card-wrapper');
    cards.forEach((card) => {
      card.addEventListener('mouseenter', function() {
        this.style.zIndex = '2';
      });
      card.addEventListener('mouseleave', function() {
        this.style.zIndex = '';
      });
    });
  }

  /* --- Smooth Header Scroll Effect --- */
  function initHeaderEffect() {
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.style.background = 'rgba(10, 10, 15, 0.95)';
      } else {
        header.style.background = 'rgba(10, 10, 15, 0.85)';
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- Smooth Accordion Open/Close --- */
  function initAccordions() {
    const allDetails = document.querySelectorAll('.accordion details');
    if (!allDetails.length) return;

    allDetails.forEach(function(details) {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      // Wrap content in animation container if not already wrapped
      if (!content.querySelector('.aq-accordion-inner')) {
        const inner = document.createElement('div');
        inner.className = 'aq-accordion-inner';
        while (content.firstChild) {
          inner.appendChild(content.firstChild);
        }
        content.appendChild(inner);
      }

      summary.addEventListener('click', function(e) {
        e.preventDefault();
        const inner = content.querySelector('.aq-accordion-inner');

        if (details.open) {
          // --- CLOSE animation ---
          details.classList.add('is-closing');

          inner.addEventListener('transitionend', function handler() {
            inner.removeEventListener('transitionend', handler);
            details.open = false;
            details.classList.remove('is-closing');
          });
        } else {
          // --- OPEN animation ---
          details.open = true;

          // Measure real height for smooth animation
          var realHeight = inner.scrollHeight;
          inner.style.setProperty('--aq-acc-height', realHeight + 'px');

          // Force reflow so transition triggers
          inner.offsetHeight;
        }
      });
    });
  }

  /* --- Animated Stats Counter --- */
  function initStatsCounter() {
    var counters = document.querySelectorAll('.aq-stats__number[data-target]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-target'), 10);
        if (isNaN(target)) return;

        var duration = 2000;
        var start = 0;
        var startTime = null;

        function easeOut(t) {
          return 1 - Math.pow(1 - t, 3);
        }

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var progress = Math.min((timestamp - startTime) / duration, 1);
          var value = Math.floor(easeOut(progress) * target);
          el.textContent = value.toLocaleString('ro-RO');
          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            el.textContent = target.toLocaleString('ro-RO');
          }
        }

        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    }, { threshold: 0.3 });

    counters.forEach(function(c) { observer.observe(c); });
  }

  /* --- Custom Metafield Filters (Collection Pages) --- */
  function initMetafieldFilters() {
    var filtersContainer = document.getElementById('aq-metafield-filters');
    if (!filtersContainer) return;

    var checkboxes = filtersContainer.querySelectorAll('.aq-mf-filter__checkbox');
    var rangeSliders = filtersContainer.querySelectorAll('.aq-mf-filter--range');

    if (!checkboxes.length && !rangeSliders.length) return;

    // Extract first numeric value from a string like "12000 DPI" or "8000-16000"
    function extractNum(s) {
      if (!s) return null;
      var clean = String(s).replace(/[.,]/g, '').match(/\d+/);
      return clean ? parseInt(clean[0], 10) : null;
    }

    function applyFilters() {
      // Collect checkbox filters (split into metafield-based and tag-based)
      var activeFilters = {};
      var activeTagFilters = {};
      checkboxes.forEach(function(cb) {
        if (cb.checked) {
          var key = cb.getAttribute('data-filter-key');
          var val = cb.getAttribute('data-filter-value');
          var isTag = cb.classList.contains('aq-mf-filter__checkbox--tag');
          var tagVal = cb.getAttribute('data-filter-tag');

          if (isTag && tagVal) {
            if (!activeTagFilters[key]) activeTagFilters[key] = [];
            activeTagFilters[key].push(tagVal);
          } else {
            if (!activeFilters[key]) activeFilters[key] = [];
            activeFilters[key].push(val);
          }
        }
      });

      // Collect range filters
      var rangeFilters = {};
      rangeSliders.forEach(function(rs) {
        var key = rs.getAttribute('data-filter-key');
        var slider = rs.querySelector('.aq-mf-range__slider');
        if (!slider) return;
        var min = parseInt(slider.getAttribute('data-min'), 10);
        var max = parseInt(slider.getAttribute('data-max'), 10);
        var minInput = slider.querySelector('.aq-mf-range__input--min');
        var maxInput = slider.querySelector('.aq-mf-range__input--max');
        var curMin = parseInt(minInput.value, 10);
        var curMax = parseInt(maxInput.value, 10);

        // Only set as active if user changed range from defaults
        if (curMin > min || curMax < max) {
          rangeFilters[key] = { min: curMin, max: curMax };
        }
      });

      var filterKeys = Object.keys(activeFilters);
      var rangeKeys = Object.keys(rangeFilters);
      var tagKeys = Object.keys(activeTagFilters);
      var cards = document.querySelectorAll('.card-wrapper.product-card-wrapper');
      var visibleCount = 0;

      cards.forEach(function(card) {
        var li = card.closest('li.grid__item');
        if (!li) li = card;

        if (filterKeys.length === 0 && rangeKeys.length === 0 && tagKeys.length === 0) {
          li.classList.remove('aq-mf-hidden');
          visibleCount++;
          return;
        }

        var matchesAll = true;

        // Checkbox filters (substring match, case-insensitive)
        for (var i = 0; i < filterKeys.length; i++) {
          var key = filterKeys[i];
          var cardVal = (card.getAttribute('data-mf-' + key) || '').trim();
          var cardValLower = cardVal.toLowerCase();
          var matchesGroup = activeFilters[key].some(function(v) {
            return cardValLower.indexOf(v.toLowerCase()) !== -1;
          });
          if (!matchesGroup) { matchesAll = false; break; }
        }

        // Tag-based filters (OR within group)
        if (matchesAll) {
          var cardTags = (card.getAttribute('data-product-tags') || '').toLowerCase();
          for (var t = 0; t < tagKeys.length; t++) {
            var tKey = tagKeys[t];
            var matchesTag = activeTagFilters[tKey].some(function(tag) {
              return cardTags.indexOf(tag.toLowerCase()) !== -1;
            });
            if (!matchesTag) { matchesAll = false; break; }
          }
        }

        // Range filters (numeric)
        if (matchesAll) {
          for (var j = 0; j < rangeKeys.length; j++) {
            var rKey = rangeKeys[j];
            var rVal = card.getAttribute('data-mf-' + rKey) || '';
            var num = extractNum(rVal);
            if (num === null || num < rangeFilters[rKey].min || num > rangeFilters[rKey].max) {
              matchesAll = false;
              break;
            }
          }
        }

        if (matchesAll) {
          li.classList.remove('aq-mf-hidden');
          visibleCount++;
        } else {
          li.classList.add('aq-mf-hidden');
        }
      });

      // Update active count badges
      filtersContainer.querySelectorAll('.aq-mf-filter').forEach(function(filterGroup) {
        var key = filterGroup.getAttribute('data-filter-key');
        var isRange = filterGroup.classList.contains('aq-mf-filter--range');
        var count = 0;
        if (isRange && rangeFilters[key]) {
          count = 1;
        } else if (activeTagFilters[key]) {
          count = activeTagFilters[key].length;
        } else if (!isRange && activeFilters[key]) {
          count = activeFilters[key].length;
        }
        var badge = filterGroup.querySelector('.aq-mf-filter__active-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'aq-mf-filter__active-count';
            filterGroup.querySelector('.aq-mf-filter__label').appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      });

      var grid = document.getElementById('product-grid');
      var noResults = document.querySelector('.aq-mf-no-results');
      if (visibleCount === 0 && (filterKeys.length > 0 || rangeKeys.length > 0 || tagKeys.length > 0)) {
        if (!noResults && grid) {
          noResults = document.createElement('div');
          noResults.className = 'aq-mf-no-results';
          noResults.textContent = 'Nu s-au găsit produse cu filtrele selectate.';
          grid.appendChild(noResults);
        }
      } else if (noResults) {
        noResults.remove();
      }
    }

    // Initialize each range slider (dual-thumb behavior + numeric inputs)
    rangeSliders.forEach(function(rs) {
      var slider = rs.querySelector('.aq-mf-range__slider');
      if (!slider) return;
      var minInput = slider.querySelector('.aq-mf-range__input--min');
      var maxInput = slider.querySelector('.aq-mf-range__input--max');
      var minNumber = rs.querySelector('.aq-mf-range__number--min');
      var maxNumber = rs.querySelector('.aq-mf-range__number--max');
      var highlight = slider.querySelector('.aq-mf-range__highlight');
      var rangeMin = parseInt(slider.getAttribute('data-min'), 10);
      var rangeMax = parseInt(slider.getAttribute('data-max'), 10);

      function updateUI(source) {
        var lo = parseInt(minInput.value, 10);
        var hi = parseInt(maxInput.value, 10);

        // Prevent thumbs from crossing
        if (lo > hi - 100) {
          if (source === 'min') lo = Math.min(hi - 100, lo);
          else hi = Math.max(lo + 100, hi);
          minInput.value = lo;
          maxInput.value = hi;
        }

        // Sync number inputs (without recursively triggering)
        if (minNumber && parseInt(minNumber.value, 10) !== lo) minNumber.value = lo;
        if (maxNumber && parseInt(maxNumber.value, 10) !== hi) maxNumber.value = hi;

        if (highlight) {
          var range = rangeMax - rangeMin;
          var leftPct = ((lo - rangeMin) / range) * 100;
          var rightPct = ((hi - rangeMin) / range) * 100;
          highlight.style.left = leftPct + '%';
          highlight.style.right = (100 - rightPct) + '%';
        }
      }

      // Slider thumbs
      minInput.addEventListener('input', function() { updateUI('min'); });
      maxInput.addEventListener('input', function() { updateUI('max'); });
      minInput.addEventListener('change', applyFilters);
      maxInput.addEventListener('change', applyFilters);

      // Numeric inputs sync to slider
      if (minNumber) {
        minNumber.addEventListener('input', function() {
          var v = parseInt(minNumber.value, 10);
          if (isNaN(v)) return;
          v = Math.max(rangeMin, Math.min(rangeMax, v));
          minInput.value = v;
          updateUI('min');
        });
        minNumber.addEventListener('change', applyFilters);
      }
      if (maxNumber) {
        maxNumber.addEventListener('input', function() {
          var v = parseInt(maxNumber.value, 10);
          if (isNaN(v)) return;
          v = Math.max(rangeMin, Math.min(rangeMax, v));
          maxInput.value = v;
          updateUI('max');
        });
        maxNumber.addEventListener('change', applyFilters);
      }

      updateUI();
    });

    checkboxes.forEach(function(cb) {
      cb.addEventListener('change', applyFilters);
    });

    var isDesktop = window.innerWidth >= 750;
    filtersContainer.querySelectorAll('.aq-mf-filter__disclosure--auto').forEach(function(details) {
      if (isDesktop) {
        details.setAttribute('open', '');
      }
    });
  }

  /* --- Initialize --- */
  function init() {
    initStickyATC();
    initScrollAnimations();
    initCardHoverEffects();
    initHeaderEffect();
    initAccordions();
    initStatsCounter();
    initMetafieldFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
